import { dequal } from 'dequal'
import { ROUTES } from '@constants/index'
import { HostEnvironment } from '@typesApp/Environment'
import { normalizeBrand } from '@utils/normalizeBrand'

/**
 * Commerce app may use a specific user id for the anonymous user.
 * e.g. N1 sends -1002, but we allow for commerce app to override
 * this value via the session.anonymousUserId configuration.
 */
const DEFAULT_ANONYMOUS_USER_ID = '-1002'

export const normalizeEnvironment = (environment: HostEnvironment | undefined): HostEnvironment | null => {
  if (!environment) return null

  return {
    ...environment,
    brand: normalizeBrand(environment.brand),
    basePath: getBasePath(),
    basePathSearch: window.location.search ?? '',
    anonymousUserId: `${environment.anonymousUserId ?? DEFAULT_ANONYMOUS_USER_ID}`,
  }
}

const getBasePath = (): string => {
  const routeBase = ROUTES.BASE.replace('/', '')

  // eslint-disable-next-line no-restricted-globals
  let basePath = window.location.pathname
  const pathArray = basePath.split('/')
  if (pathArray.includes(routeBase)) {
    const dbIndex = pathArray.indexOf(routeBase)
    basePath = pathArray.slice(0, dbIndex).join('/')
  }
  return basePath
}

export const isEnvironmentChanged = (
  source: HostEnvironment | undefined,
  target: HostEnvironment | undefined
): boolean => {
  return !dequal(source, target)
}

export const initGlobalLocale = (environment: HostEnvironment) => {
  if (window.directBilling?.env) {
    window.directBilling.env.locale = environment.locale
    window.directBilling.env.currency = environment.currency
  }
}
